import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import ComputerOutlinedIcon from '@mui/icons-material/ComputerOutlined'
import { CHROME_RADIUS } from 'core/theme.tokens'

interface DesktopOnlyNoticeProps {
  /** Feature name shown in the heading, e.g. "Campaigns". */
  feature: string
  detail?: string
}

/** Phone placeholder when a screen stays desktop-only. */
export const DesktopOnlyNotice: React.FC<DesktopOnlyNoticeProps> = ({
  feature,
  detail = 'Open this on a computer for the full layout.',
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1.5,
        px: 3,
        py: 6,
        textAlign: 'center',
        borderRadius: `${CHROME_RADIUS}px`,
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
      }}
    >
      <ComputerOutlinedIcon sx={{ fontSize: 40, color: 'text.secondary' }} />
      <Typography variant='subtitle1' sx={{ fontWeight: 700 }}>
        {feature} — use a computer
      </Typography>
      <Typography variant='body2' color='text.secondary' sx={{ maxWidth: 320 }}>
        {detail}
      </Typography>
    </Box>
  )
}
